import React, { useEffect, useState } from "react";

import { DivMarcas, BrandLabel, TitleProduct } from "./styles";
import { Container } from "react-bootstrap";
import CustomAlphabetList from "components/CustomAlphabetList";
import { produtosApi } from '../../../page/OrderResumePag/_services/api';
import { useNavigate } from "react-router";
import SearchInput from "components/SearchInput";
import Scroll from "components/ScrollToTop";
import Header from "components/HeaderNoMenuContent";
import Title from "components/Title";
import { useOpen } from "hooks/Open";
import { trackClick } from "../../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../../hooks/useScreenTracking";

export default function Brands() {
  const { OpenButton, setBrands, forceCloseAllMenu } = useOpen();
  const navigate = useNavigate();
  const screenName = useScreenTracking();
  const TAG_ID = "03";
  const LIST_SCREEN_NAME = "lista-marcas";
  const CONTENT_TYPE = "lista-marcas";
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  async function getBrands() {
    const response = await produtosApi.get(`/v1/marca/${process.env.REACT_APP_DEFAULT_CHANNEL}`);
    return response.data.data;
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const brands = await getBrands();

        const grouped = brands.reduce((acc, item) => {
          if (!acc[item.label]) {
            acc[item.label] = {
              id: item.id,
              label: item.label,
              image: item.image,
              ids: [item.id],
            };
          } else {
            acc[item.label].ids.push(item.id);
          }
          return acc;
        }, {});

        setData(Object.values(grouped));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const redirectPage = (label) => {

    setBrands(false);
    OpenButton();

    const returnItem = data.find((item) => item.label === label);
    if (!returnItem) return;

    trackClick({
      title: label.toLowerCase().replace(/\s/g, '-'),
      contentType: CONTENT_TYPE,
      screenName: LIST_SCREEN_NAME,
      tagId: tagIdFromLegacySuffix(TAG_ID)
    });

    forceCloseAllMenu();

    navigate(`/loja/brands/${returnItem.id}?ids=${returnItem.ids.join(",")}`);

  };

  const labelBrands = data.map((item) => item.label);
  const filterBrands = search
    ? labelBrands.filter((item) =>
        item.toLowerCase().includes(search.toLowerCase())
      )
    : labelBrands;

  return (
    <div className="wl-page mt-4">
      <Container>
        <Title label="Marcas" />
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e)}
          placeholder="Procurar marcas"
        />

        {loading ? (
          <div className="text-center">
            <p className="fs-6">Carregando marcas </p>
          </div>
        ) : !filterBrands.length ? (
          <div className="text-center">
            <p className="fs-6">Nenhuma marca encontrada </p>
          </div>
        ) : (
          <DivMarcas className="mt-5">
            <div className="div-list">
              <CustomAlphabetList
                style={{
                  position: "initial",
                  marginBottom: "200px",
                  paddingRight: "0",
                }}
                className="alpha-list"
                data={filterBrands}
                generateFn={(label, index) => {
                  return (
                    <div key={label + index} style={{ paddingRight: "0" }}>
                      <BrandLabel
                        className="font-wl-400 text-mg"
                        onClick={() => redirectPage(label)}
                      >
                        {label}
                      </BrandLabel>
                    </div>
                  );
                }}
              />
            </div>
          </DivMarcas>
        )}
      </Container>
      <Scroll />
    </div>
  );
}
